// extracted by mini-css-extract-plugin
export default {"visuallyhidden":"long-description__visuallyhidden--mxQ2m","focusable":"long-description__focusable--fTBX2","longDescription":"long-description__longDescription--texbF"};